var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 46,
    viewBox: "0 0 120 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.33 27.94C50.81 36.15 54.6 40.16 58.68 45.79H60.81C64.9 40.16 68.65 36.15 86.16 27.94C103.95 19.6 114.61 11.19 119.38 1.5L113.23 0.98C108.57 8.68 99.05 15.67 83.77 22.84C78.9731 25.0335 74.2995 27.4872 69.77 30.19C68.3314 28.8159 66.794 27.5491 65.17 26.4C67.69 25.07 70.67 23.65 74.17 22.11C92.42 14.11 101.17 7.16 105.59 0.42C103.363 0.266667 101.127 0.126667 98.88 0C94.55 5 86.66 10.5 71.88 16.94C67.7067 18.7225 63.6309 20.7253 59.67 22.94C55.7066 20.7235 51.6274 18.7207 47.45 16.94C32.81 10.5 24.92 4.95 20.59 0C18.3433 0.126667 16.1067 0.266667 13.88 0.42C18.29 7.16 27.05 14.1 45.3 22.1C48.84 23.64 51.81 25.1 54.3 26.39C52.6741 27.5366 51.1364 28.8035 49.7 30.18C45.169 27.4799 40.4955 25.0263 35.7 22.83C20.44 15.67 10.93 8.68 6.26 0.98L0.119995 1.5C4.89 11.19 15.55 19.6 33.33 27.94ZM59.81 29.52C61.6574 30.6781 63.4066 31.9858 65.04 33.43C63.1516 34.8161 61.4002 36.3799 59.81 38.1C58.2216 36.366 56.4702 34.7888 54.58 33.39C56.2131 31.9573 57.9624 30.6628 59.81 29.52Z",
    fill: "#C18F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.ea72329620b308a5505746c3533e7382.svg";
export { ForwardRef as ReactComponent };